module.exports = __webpack_public_path__ + "static/img/15.8985f2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/15.png
// module id = uUMo
// module chunks = 1